<template>
  <div class="homePage">
    <Header1 />
    <Dialog1 />
    <div class="wrap">
      <section class="swiper_wrap">
        <!--          <img :src="imgUrl" class="swiper-img">-->
        <swiper :options="swiperOption">
            <swiper-slide>
                <router-link to="/eduday" tag="a">
                    <img src="../../assets/P-2-banner.png" class="swiper-img" />
                </router-link>
            </swiper-slide>
            <swiper-slide>
                <router-link to="/edumon" tag="a">
                    <img src="../../assets/P-1-banner.png" class="swiper-img" />
                </router-link>
            </swiper-slide>
            <swiper-slide>
                <router-link to="/advEdu" tag="a">
                    <img src="../../assets/banner_03.png" class="swiper-img" />
                </router-link>
            </swiper-slide>
            <swiper-slide>
                <router-link to="/eduNew" tag="a">
                    <img src="../../assets/edu.png" class="swiper-img" />
                </router-link>
            </swiper-slide>
          <!-- <swiper-slide>
            <router-link to="/edu" tag="a">
              <img src="../../assets/homeSwiper0_button.jpg" class="swiper-img" />
            </router-link>
          </swiper-slide> -->
          
          <!-- <swiper-slide>
            <img src="../../assets/homeSwiper1.jpg" class="swiper-img" />
          </swiper-slide>
          <swiper-slide>
            <img src="../../assets/homeSwiper2.jpg" class="swiper-img" />
          </swiper-slide> -->
          <!--              <swiper-slide v-for='item of swiperList' :key="item.id">-->
          <!--                <img :src="item.imgUrl" class="swiper-img">-->
          <!--              </swiper-slide>-->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </section>
    </div>

    <Footer1 />
  </div>
</template>
<script>
import Header1 from "../header";
import Dialog1 from "./dialog";
import Footer1 from "../footer";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  name: "home",
  components: {
    Header1,
    Dialog1,
    Footer1,
    Swiper,
    SwiperSlide
  },

  props: {},

  data() {
    return {
      swiperOption: {
        spaceBetween: 30,
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }, //分页器挂载到swiper-pagination类对应的元素上
        loop: true, //开启轮播图前后循环模式
        autoplay: {
          delay: 3000,
          disableOnInteraction: false //被操作的时候不切换
        }
      },
      swiperList: [
        {
          id: "0001",
          imgUrl: "../../assets/homeSwiper1.jpg"
        },
        {
          id: "0002",
          imgUrl: "../../assets/homeSwiper2.jpg"
        }
      ]
    };
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {}
};
</script>

<style scoped lang="scss">
.homePage {
  height: 100%;
  .wrap {
    padding: 6rem 0;
    // height: 74%;
    .swiper_wrap {
      // height: 100%;
      overflow: hidden;
      width: 100%;
      background: #eee;
      .swiper-img {
        width: 100%;
        margin-bottom: 0;
        display:block;
      }
    }
  }
}
</style>
<style>
.swiper-container {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue